import { EmbedTheme } from "../../utils/embeds"
import { V3IconRedirect } from "../Icons"
import { UnstyledLink } from "../ReusableStyledComponents/UnstyledLink"
import { V3EmbedPoweredBy } from "../V3EmbedContent"
import { V3EmbedCollBody } from "./V3EmbedCollection.styles"
import { V3EmbedFooterCTA, V3EmbedLinkToOriginal } from "./V3EmbedCTA.styles"

interface V3EmbedCTAProps {
    target: string,
    label: string,
    embedTheme: EmbedTheme,
    utmCampaign: string
}

export const V3EmbedCTA = ({ target, embedTheme, label, utmCampaign }: V3EmbedCTAProps) => {
    return <V3EmbedFooterCTA>
        <div>
            <UnstyledLink href={target} target="_blank">
                <V3EmbedLinkToOriginal>
                    <div><V3EmbedCollBody $embedTheme={embedTheme} $numLines={1}><strong>{label}</strong></V3EmbedCollBody></div>
                    <div><V3IconRedirect /></div>
                </V3EmbedLinkToOriginal>
            </UnstyledLink>
        </div>
        <div>
            <V3EmbedPoweredBy embedTheme={embedTheme} utmCampaign={utmCampaign} />
        </div>
    </V3EmbedFooterCTA>
}